const AlertTriangle = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="16"
    viewBox="0 0 18 16"
    fill="none"
  >
    <path
      d="M9.00226 5.75017V8.75017M9.00226 11.7502H9.00976M7.96375 1.91897L1.79508 12.5739C1.45293 13.1649 1.28185 13.4604 1.30714 13.7029C1.32919 13.9145 1.44002 14.1067 1.61204 14.2318C1.80925 14.3752 2.1507 14.3752 2.83359 14.3752H15.1709C15.8538 14.3752 16.1953 14.3752 16.3925 14.2318C16.5645 14.1067 16.6753 13.9145 16.6974 13.7029C16.7227 13.4604 16.5516 13.1649 16.2094 12.5739L10.0408 1.91896C9.69984 1.33009 9.52938 1.03566 9.30698 0.936765C9.11299 0.850505 8.89153 0.850505 8.69753 0.936765C8.47514 1.03566 8.30467 1.33009 7.96375 1.91897Z"
      stroke="#F73C3C"
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default AlertTriangle;
